import { TProjectExportState } from '@/redux/reducers/project-export';
import { TProjectExportManualSuccess } from '@/redux/actions/project-export';

export const projectExportManualUpdateState = (
  state: TProjectExportState,
  action: TProjectExportManualSuccess,
): TProjectExportState => {
  const updatedState = {
    ...state,
    projectExportManualResponse: action.payload.response,
  };

  return updatedState;
};
